import * as React from "react";
import { Spinner } from "azure-devops-ui/Spinner";

export default class SpinnerLabelExample extends React.Component<any, any> {
    public render() {
        return (
            <div className="flex-row">
                <Spinner label="loading" />
            </div>
        );
    }
}
